import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import InputRange from 'react-input-range';

import SpotlioIcon from '../../components/Icon';
import Currency from "../../components/Currency";
import UnitRatings from "../../components/UnitRatings";
import Input from "../../components/Input";
import TextField from '@material-ui/core/TextField';

import IntlMessage from '../../LocaleEngine';

import { getLodgingFilters, setLodgingFilters } from "../../utils/SettingsRetriever";
import QueryStringRetriever from '../../utils/QueryStringRetriever';

import 'react-input-range/lib/css/index.css';

export default class FiltersBar extends React.Component {
    constructor(props) {
        super(props);

        this.defaultFiltersOrder = [ 'name', 'price', 'supplier', 'rating', 'neighborhood', 'room_type', 'bedroom', 'property_amenity', 'room_amenity', 'trustyou', 'packages'  ];

        this.state = {
            propertyName: '',
            name: true,
            neighborhood: false,
            bedroom: false,
            roomType: false,
            suppliers: [],
            neighborhoods: [],
            packages: [],
            trustYous: [],
            filtersOrder: (this.props.config && this.props.config.config && this.props.config.config.filtersOrder) || this.defaultFiltersOrder,
            neighbordhoodsColors: [],
            suggestions: [],
            make: this.props.make,
            trustyou: false,
            roomTypes: [],
            roomAmenities: [],
            propertyAmenities: [],
            bedrooms: [],
            ratings: [],
            rangePrices:{
                min:0,
                max: 0,
            },
            price: false,
            selectedPrices:{
                min: 0,
                max: 0
            },
            selectedSupplier: undefined,
            selectedNeighborhoods: [],
            selectedPackages: [],
            selectedSuppliers: [],
            selectedTrustYous: [],
            selectedRoomType: undefined,
            selectedRoomAmenities: [],
            selectedPropertyAmenities: [],
            selectedBedroom: undefined,
            selectedRatings: [],
            filters: {
                name: false, 
                neighborhood: false, 
                price: false, 
                roomAmenity: false, 
                roomType: false, 
                trustyou: false,
                bedroom: false, 
                packages: false,
                propertyAmenity: false,
                rating: false
            }
        }
    }

    componentDidMount() {
        let filters = getLodgingFilters();
        this.buildFilters(this.props.suppliers);
        if (filters){
            this.setState({ ...filters }, () => {
                this.handleFiltersChange();
            })
        } 

        const queryString = QueryStringRetriever();
        if (queryString) {
            const state = { ...this.state };
            Object.keys(queryString).forEach(key => {
                const formattedQueryStringName = `selected${key.charAt(0).toUpperCase() + key.slice(1)}`;
                if (state.hasOwnProperty(formattedQueryStringName)) {
                    if (queryString[key].indexOf(",") > 0) {
                        state[formattedQueryStringName] = queryString[key].split(",")
                    } else {
                        if (Array.isArray(state[formattedQueryStringName])) {
                            state[formattedQueryStringName] = [queryString[key]]
                        } else {
                            state[formattedQueryStringName] = queryString[key]
                        }
                    }
                }
            })

            this.setState({ ...state }, () => {
                setTimeout(() => this.handleFiltersChange(), 100)
            });
        }
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.rebuildFilters){
            this.setState({make: nextProps.make}, () => {
                this.buildFilters(nextProps.suppliers);
                this.props.handleBuildFilters();
            })
        }
    }

    buildFilters = (suppliers) => {
        if (this.props.config.config.filterOptions.neighborhood && this.props.config.config.filterOptions.neighborhood.enabled){
            this.handleBuildNeighborhoods(suppliers, undefined, undefined, this.props.config.config.filterOptions.neighborhood.order);
        }
        if (this.props.config.config.filterOptions.name && this.props.config.config.filterOptions.name.enabled){
            this.handleBuildSupplierList(suppliers);
        }
        if (this.props.config.config.filterOptions.price && this.props.config.config.filterOptions.price.enabled && this.props.make){
            this.handleBuildPrice(suppliers)
        }
        if (this.props.config.config.filterOptions.bedrooms.enabled && this.props.make){
            this.handleBuildBedrooms(suppliers)
        }
        if (this.props.config.config.filterOptions.roomTypes.enabled && this.props.make){
            this.handleBuildRoomTypes(suppliers)
        }
        if (this.props.config.config.filterOptions.packages && this.props.config.config.filterOptions.packages.enabled && this.props.make){
            this.handleBuildPackages(suppliers)
        }
        if (this.props.config.config.filterOptions.rating && this.props.config.config.filterOptions.rating.enabled && this.props.make){
            this.handleBuildRatings(suppliers);
        }
        if (this.props.config.config.filterOptions.propertyAmenities && this.props.config.config.filterOptions.propertyAmenities.enabled){
            this.handleBuildPropertyAmenities(suppliers)
        }
        if (this.props.config.config.filterOptions.roomAmenities && this.props.config.config.filterOptions.roomAmenities.enabled && this.props.make){
            this.handleBuildRoomAmenities(suppliers)
        }
    }

    /* all individual filter builds */
    handleBuildBedrooms(suppliers, update, lastFilter) {
        let bedrooms = this.state.bedrooms
        if (update){
            if (lastFilter === "bedroom"){
                bedrooms.forEach( (bedroom) => {
                    if (this.state.selectedBedroom === undefined){
                        bedroom.splice(2, 1)
                    } else {
                        if (this.state.selectedBedroom === bedroom[0]){
                            bedroom[2] = "selected";
                        } else {
                            bedroom[2] = "+"
                        }
                    }
                })
            } else {
                bedrooms.forEach( (bedroom) => {
                    bedroom[1] = 0
                })

                let newSuppliers = this.handleFiltersChange("ignoreBedrooms")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                        supplier.Products_Lodging.forEach((room) => {
                            bedrooms.forEach( (bedroom) => {
                                if (bedroom[0] === room.Bedrooms){
                                    bedroom[1] += 1
                                }
                            })
                        })
                    }
                })
            }
            this.setState({ bedrooms })
        } else {
            let bedrooms = [];
            let bedroomsCounter = [];
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                    supplier.Products_Lodging.forEach((room) => {
                        if (room.WithDen) {
                            if (bedrooms.indexOf("Den") === -1){
                                bedrooms.push("Den")
                                bedroomsCounter.push(1)
                            } else {
                                bedroomsCounter[bedrooms.indexOf("Den")] += 1
                            }
                        } else {
                            if (bedrooms.indexOf(room.Bedrooms) === -1){
                                bedrooms.push(room.Bedrooms)
                                bedroomsCounter.push(1)
                            } else {
                                bedroomsCounter[bedrooms.indexOf(room.Bedrooms)] += 1
                            }
                        }
                        
                    })
                }
            })
            for (let i = 0; i < bedrooms.length; i++){
                finalArray.push([bedrooms[i], bedroomsCounter[i]])
            }
            
            this.setState({ 
                bedrooms: finalArray.sort((a, b) => { return a[0] - b[0] })
            })
        }
    }

    handleBuildPropertyAmenities = (suppliers, update, lastFilter) => {
        let propertyAmenities = this.state.propertyAmenities;
        if (update){
            if (lastFilter === "propertyAmenities"){
                propertyAmenities.forEach( (propertyAmenity) => {
                    if (this.state.selectedPropertyAmenities.length === 0){
                        propertyAmenity.splice(2, 1)
                    } else {
                        if (this.state.selectedPropertyAmenities.indexOf(propertyAmenity[0]) >= 0){
                            propertyAmenity[2] = "selected";
                        } else {
                            propertyAmenity[2] = "+"
                        }
                    }
                })
                this.setState({ propertyAmenities: propertyAmenities })
            } else {
                propertyAmenities.forEach( (propertyAmenity) => {
                    propertyAmenity[1] = 0
                })

                let newSuppliers = this.handleFiltersChange("ignorePropertyAmenities")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                        propertyAmenities.forEach((amenity) => {
                            if (supplier.SupplierAttributes.find(attr => amenity[0] === attr.Name)){
                                amenity[1] += supplier.Products_Lodging.length;
                            }
                        })
                    }
                })
                this.setState({ propertyAmenities })
            }
        } else {
            let propertyAmenities = [];
            let propertyAmenitiesCounter = [];
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                    supplier.SupplierAttributes.forEach((attr) => {
                        if (attr.CodeType === 42){
                            if (propertyAmenities.indexOf(attr.Name) === -1){
                                propertyAmenities.push(attr.Name)
                                propertyAmenitiesCounter.push(supplier.Products_Lodging.length)
                            } else {
                                propertyAmenitiesCounter[propertyAmenities.indexOf(attr.Name)] += supplier.Products_Lodging.length
                            }
                        }
                    })
                }
            })
            for (let i = 0; i < propertyAmenities.length; i++){
                finalArray.push([propertyAmenities[i], propertyAmenitiesCounter[i]])
            }
            if (this.props.config.config.filterOptions.propertyAmenities.whiteList){
                let auxArray = finalArray.filter(amenity => { return this.props.config.config.filterOptions.propertyAmenities.whiteList.find(propertyAmenity => propertyAmenity === amenity[0]) })
                if (auxArray.length > 0) finalArray = auxArray;
            }
            this.setState({ propertyAmenities: finalArray })
        }
    }

    handleBuildRoomAmenities = (suppliers, update, lastFilter) => {
        let roomAmenities = this.state.roomAmenities;
        if (update){
            if (lastFilter === "roomAmenities"){
                roomAmenities.forEach( (roomAmenity) => {
                    if (this.state.selectedRoomAmenities.length === 0){
                        roomAmenity.splice(2, 1)
                    } else {
                        if (this.state.selectedRoomAmenities.indexOf(roomAmenity[0]) >= 0){
                            roomAmenity[2] = "selected";
                        } else {
                            roomAmenity[2] = "+"
                        }
                    }
                })
                this.setState({ roomAmenities: roomAmenities })
            } else {
                roomAmenities.forEach( (roomAmenity) => {
                    roomAmenity[1] = 0
                })

                let newSuppliers = this.handleFiltersChange("ignoreRoomAmenities")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                        supplier.Products_Lodging.forEach((room) => {
                            roomAmenities.forEach( (roomAmenity) => {
                                if (room.Attributes.find(attr => attr.Name === roomAmenity[0])){
                                    roomAmenity[1] += 1
                                }
                            })
                        })
                    }
                })
                this.setState({ roomAmenities })
            }
        } else {
            let roomAmenities = [];
            let roomAmenitiesCounter = [];
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                    supplier.Products_Lodging.forEach((room) => {
                        room.Attributes.forEach((attr => {
                            if (attr.CodeType === 53){
                                if (roomAmenities.indexOf(attr.Name) === -1){
                                    roomAmenities.push(attr.Name)
                                    roomAmenitiesCounter.push(1)
                                } else {
                                    roomAmenitiesCounter[roomAmenities.indexOf(attr.Name)] += 1
                                }
                            }
                        }))
                    })
                }
            })
            for (let i = 0; i < roomAmenities.length; i++){
                finalArray.push([roomAmenities[i], roomAmenitiesCounter[i]])
            }
            if (this.props.config.config.filterOptions.roomAmenities.whiteList){
                let auxArray = finalArray.filter(amenity => { return this.props.config.config.filterOptions.roomAmenities.whiteList.find(roomAmenity => roomAmenity === amenity[0]) })
                if (auxArray.length > 0) finalArray = auxArray;
            }
            this.setState({ roomAmenities: finalArray })
        }
    }

    handleBuildRoomTypes(suppliers, update, lastFilter) {
        let roomTypes = this.state.roomTypes;
        if (update){
            if (lastFilter === "roomTypes"){
                roomTypes.forEach( (roomType) => {
                    if (this.state.selectedRoomType === undefined){
                        roomType.splice(2, 1)
                    } else {
                        if (this.state.selectedRoomType.indexOf(roomType[0]) >= 0){
                            roomType[2] = "selected";
                        } else {
                            roomType[2] = "+"
                        }
                    }
                })
                this.setState({ roomTypes: roomTypes })
            } else {
                roomTypes.forEach( (roomType) => {
                    roomType[1] = 0
                })

                let newSuppliers = this.handleFiltersChange("ignoreRoomTypes")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                        supplier.Products_Lodging.forEach((room) => {
                            roomTypes.forEach( (roomType) => {
                                if (roomType[0] === room.Type){
                                    roomType[1] += 1
                                }
                            })
                        })
                    }
                })
                this.setState({ roomTypes })
            }
        } else {
            let roomTypes = [];
            let roomTypesCounter = [];
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                    supplier.Products_Lodging.forEach((room) => {
                        if (roomTypes.indexOf(room.Type) === -1){
                            roomTypes.push(room.Type)
                            roomTypesCounter.push(1)
                        } else {
                            roomTypesCounter[roomTypes.indexOf(room.Type)] += 1
                        }
                    })
                }
            })
            for (let i = 0; i < roomTypes.length; i++){
                finalArray.push([roomTypes[i], roomTypesCounter[i]])
            }
            this.setState({ roomTypes: finalArray })
        }
    }

    handleBuildPrice(suppliers){
        let minPrice = undefined;
        let maxPrice = undefined;

        suppliers.forEach((supplier, idx) => {
            if (supplier && supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                supplier.Products_Lodging.forEach((room, index) => {
                    if (room.FromPrice < minPrice || minPrice === undefined) minPrice = room.FromPrice
                    if (room.FromPrice > maxPrice || maxPrice === undefined) maxPrice = room.FromPrice
                })
            }
        });

        this.setState({ rangePrices: { min: Math.floor(minPrice), max: Math.ceil(maxPrice) }, selectedPrices: { min: Math.floor(minPrice), max: Math.ceil(maxPrice) } })
        
        return null;
    }

    handleBuildSupplierList(suppliers) {
        let arraySuppliers = [];
        let selectedSuppliers = {};
        suppliers.forEach(val => {
            if (val !== undefined){
                if ( (this.state.make && val.Products_Lodging && val.Products_Lodging.length > 0) || !this.state.make){
                    if (arraySuppliers.indexOf(val.Supplier.SupplierName) < 0) {
                        arraySuppliers.push(val.Supplier.SupplierName);
                        selectedSuppliers[val.Supplier.SupplierName] = false;
                    }
                }
            }
        });
        let state = this.state
        state.suppliers = arraySuppliers;
        state.selectedSuppliers = arraySuppliers
        this.setState(state)
    }

    handleBuildNeighborhoods = (suppliers, update, lastFilter, orderedArray) => {
        if (update){
            let state = this.state
            if (lastFilter === "neighborhoods"){
                // si el ultimo filtro que he aplicado es en el que estás,
                state.neighborhoods.forEach( (neighborhood) => {
                    if (this.state.selectedNeighborhoods.length === 0){
                        neighborhood.splice(2, 1)
                    } else {
                            // o quitar el número porque es el filtro seleccionado

                        if (this.state.selectedNeighborhoods.indexOf(neighborhood[0]) >= 0){
                            neighborhood[2] = "selected";
                        } else {
                            // solo tendrás que añadir un + delante del numero (para dar a entender que añadirás más resultados)
                            neighborhood[2] = "+"
                        }
                    }
                })
            } else {
                // si no eres el último filtro seleccionado, vacio los contadores
                // y los vuelvo a llenar, problema: si este filtro ya tiene un valor
                // seleccionado, nunca podremos poner los "+", ya que al no haber
                // cumplido la selección anteriormente, no estarán en el listado
                // y todos serán 0
                let neighborhoods = state.neighborhoods;
                neighborhoods.forEach( (neighborhood) => {
                    neighborhood[1] = 0
                })

                let newSuppliers = this.handleFiltersChange("ignoreNeighborhoods")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Neighborhood){
                        neighborhoods.forEach( (neighborhood) => {
                            if (neighborhood[0] === supplier.Neighborhood.name){
                                neighborhood[1] += this.state.make ? supplier.Products_Lodging.length : 1
                            }
                        })
                    }
                })
            }
            this.setState({state})
        } else {
            let neighborhoods = orderedArray;
            let neighborhoodsColors = [];
            let neighborhoodsCounter = [];
            let state = this.state;
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Neighborhood){
                    if (!neighborhoodsColors.find(neigh => neigh && neigh.name === supplier.Neighborhood.name)){
                        neighborhoodsColors[orderedArray.indexOf(supplier.Neighborhood.name)] = {name : supplier.Neighborhood.name, color: supplier.Neighborhood.color }
                    } 
                    if (neighborhoodsCounter[neighborhoods.indexOf(supplier.Neighborhood.name)]){
                        neighborhoodsCounter[neighborhoods.indexOf(supplier.Neighborhood.name)] += this.state.make ? supplier.Products_Lodging.length : 1
                    } else {
                        neighborhoodsCounter[neighborhoods.indexOf(supplier.Neighborhood.name)] = this.state.make ? supplier.Products_Lodging.length : 1
                    }
                }
            })
            for (let i = 0; i < neighborhoods.length; i++){
                finalArray.push([neighborhoods[i], neighborhoodsCounter[i]])
            }
            state.neighborhoods = finalArray;
            state.neighborhoodsColors = neighborhoodsColors
            this.setState(state)
        }
    }

    handleBuildTrustYou = (suppliers, update, lastFilter) => {
        if (update){
            let state = this.state
            if (lastFilter === "trustyou"){
                state.trustYous.forEach( (trustyou) => {
                    if (this.state.selectedTrustYous.length === 0){
                        trustyou.splice(2, 1)
                    } else {
                        if (this.state.selectedTrustYous.indexOf(trustyou[0]) >= 0){
                            trustyou[2] = "selected";
                        } else {
                            trustyou[2] = "+"
                        }
                    }
                })
            } else {
                let trustYous = state.trustYous;
                trustYous.forEach( (trustyou) => {
                    trustyou[1] = 0
                })
                let newSuppliers = this.handleFiltersChange("ignoreTrustyous")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Trustyou){
                        trustYous.forEach( (trustyou) => {
                            if (trustyou[0] === supplier.Trustyou.api_response.score_description){
                                trustyou[1] += this.state.make ? supplier.Products_Lodging.length : 1
                            }
                        })
                    }
                })
            }
            this.setState({state})
        } else {
            let trustyous = [];
            let trustyousCounter = [];
            let state = this.state;
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Trustyou){
                    if (trustyous.indexOf(supplier.Trustyou.api_response.score_description) === -1){
                        trustyous.push(supplier.Trustyou.api_response.score_description)
                        this.state.make ? trustyousCounter.push(supplier.Products_Lodging.length) : trustyousCounter.push(1)
                    } else {
                        trustyousCounter[trustyous.indexOf(supplier.Trustyou.api_response.score_description)] += this.state.make ? supplier.Products_Lodging.length : 1
                    }
                }
            })
            for (let i = 0; i < trustyous.length; i++){
                finalArray.push([trustyous[i], trustyousCounter[i]])
            }
            state.trustYous = finalArray;
            this.setState(state)
        }
    }

    handleBuildPackages(suppliers, update, lastFilter) {
        if (update){
            let state = this.state
            if (lastFilter === "packages"){
                state.packages.forEach( (pckg) => {
                    if (this.state.selectedPackages.length === 0){
                        pckg.splice(2, 1)
                    } else {
                        if (this.state.selectedPackages.indexOf(pckg[0]) >= 0){
                            pckg[2] = "selected";
                        } else {
                            pckg[2] = "+"
                        }
                    }
                })
            } else {
                let packages = state.packages;
                if (packages && packages.length > 0){
                    packages.forEach( (pckg) => {
                        pckg[1] = 0
                    })
                }
                
                let newSuppliers = this.handleFiltersChange("ignorePackages");
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                        supplier.Products_Lodging.forEach((room) => {
                            room.Packages.forEach(roomPackage => {
                                if (packages && packages.length > 0){
                                    packages.forEach( (pckg) => {
                                        if (pckg[0] === roomPackage.PackageName){
                                            pckg[1]++
                                        }
                                    })
                                }
                            })
                        })
                    }
                })
            }
            this.setState({ state })
        } else {
            let packages = [];
            let packagesCounter = [];
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                    supplier.Products_Lodging.forEach((room) => {
                        room.Packages.forEach(roomPackage => {
                            if (packages.indexOf(roomPackage.PackageName) === -1){
                                packages.push(roomPackage.PackageName)
                                packagesCounter.push(1)
                            } else {
                                packagesCounter[packages.indexOf(roomPackage.PackageName)] += 1
                            }
                        })
                    })
                }
            })
            for (let i = 0; i < packages.length; i++){
                finalArray.push([packages[i], packagesCounter[i]])
            }
            this.setState({ packages: finalArray })
        }
    }

    handleBuildRatings(suppliers, update, lastFilter){
        let ratings = this.state.ratings;
        if (update){
            if (lastFilter === "ratings"){
                ratings.forEach( (rating) => {
                    if (this.state.selectedRatings.length === 0){
                        rating.splice(2, 1)
                    } else {
                        if (this.state.selectedRatings.indexOf(rating[0]) >= 0){
                            rating[2] = "selected";
                        } else {
                            rating[2] = "+"
                        }
                    }
                })
                this.setState({ ratings: ratings })
            } else {
                ratings.forEach( (rating) => {
                    rating[1] = 0
                })

                let newSuppliers = this.handleFiltersChange("ignoreRatings")
                newSuppliers.forEach( (supplier) => {
                    if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                        supplier.Products_Lodging.forEach((room) => {
                            ratings.forEach( (rating) => {
                                if (room.UnitRating === rating[0]){
                                    rating[1] += 1
                                }
                            })
                        })
                    }
                })
                this.setState({ ratings })
            }
        } else {
            let ratings = [];
            let ratingsCounter = [];
            let finalArray = []
            suppliers.forEach( (supplier) => {
                if (supplier.Products_Lodging && supplier.Products_Lodging.length > 0){
                    supplier.Products_Lodging.forEach((room) => {
                        if (room.UnitRating){
                            if (ratings.find(rat => rat === room.UnitRating)){
                                ratingsCounter[ratings.indexOf(room.UnitRating)] += 1;
                            } else {
                                ratings.push(room.UnitRating)
                                ratingsCounter.push(1)
                            }
                        }
                    })
                }
            })
            for (let i = 0; i < ratings.length; i++){
                finalArray.push([ratings[i], ratingsCounter[i]])
            }
            this.setState({ ratings: finalArray })
        }
    }

    /* individual filter change functions */
    handleNeighborhoodsChange = ( value ) => {
        let selectedNeighborhoods = this.state.selectedNeighborhoods
        if (selectedNeighborhoods.indexOf(value) >=0){
            selectedNeighborhoods.splice(selectedNeighborhoods.indexOf(value), 1);
        } else {
            selectedNeighborhoods.push(value)
        }
        this.setState({selectedNeighborhoods: selectedNeighborhoods}, () => {
            this.handleFiltersChange("neighborhoods");
        })
    }

    handleTrustYouChange = ( value ) => {
        let selectedTrustYous = this.state.selectedTrustYous
        if (selectedTrustYous.indexOf(value) >=0){
            selectedTrustYous.splice(selectedTrustYous.indexOf(value), 1);
        } else {
            selectedTrustYous.push(value)
        }
        this.setState({selectedTrustYous: selectedTrustYous}, () => {
            this.handleFiltersChange("trustyou");
        })
    }

    handlePackagesChange = ( value ) => {
        let selectedPackages = this.state.selectedPackages
        if (selectedPackages.indexOf(value) >=0){
            selectedPackages.splice(selectedPackages.indexOf(value), 1);
        } else {
            selectedPackages.push(value)
        }
        this.setState({selectedPackages: selectedPackages}, () => {
            this.handleFiltersChange("packages");
        })
    }

    handlePropertyNameTextField(event) {
        this.setState({propertyName: event.target.value}, () => {
            let validation = new RegExp(this.state.propertyName, "i");
            let suggestions = this.state.suppliers.filter(supplier => supplier.match(validation));
            this.setState({ suggestions });
        });
    }

    getAutoComplete = (text, shouldBeBold) => {
        const regEx = new RegExp(shouldBeBold, "i");
        const textArray = text.split(regEx);
        const replaceText = text.match(regEx);
        return (
          <span>
            {textArray.map((item, index) => (
              <>
                {item}
                {index !== textArray.length - 1 && <b>{replaceText}</b>}
              </>
            ))}
          </span>
        );
    };

    handleBedroomChange = (selectedBedroom) => {
        if (this.state.selectedBedroom === selectedBedroom){
            this.setState({ selectedBedroom: undefined}, () => {
                this.handleFiltersChange("bedroom");
            })
        } else {
            this.setState({ selectedBedroom }, () => {
                this.handleFiltersChange("bedroom");
            })
        }
    }

    handleRoomTypeChange = (selectedRoomType) => {
        if (this.state.selectedRoomType === selectedRoomType){
            this.setState({ selectedRoomType: undefined}, () => {
                this.handleFiltersChange("roomType");
            })
        } else {
            this.setState({ selectedRoomType }, () => {
                this.handleFiltersChange("roomType");
            })
        }
    }

    handleRoomAmenityChange = (selectedRoomAmenity) => {
        let { selectedRoomAmenities } = this.state;
        if (selectedRoomAmenities.find(amenity => amenity === selectedRoomAmenity)){
            selectedRoomAmenities.splice(selectedRoomAmenities.indexOf(selectedRoomAmenity), 1)
        } else {
            selectedRoomAmenities.push(selectedRoomAmenity)
        }

        this.setState({ selectedRoomAmenities }, () => {
            this.handleFiltersChange("roomAmenities");
        })
    }

    handleRatingChange = (selectedRating) => {
        let { selectedRatings } = this.state;
        if (selectedRatings.find(rating => rating === selectedRating)){
            selectedRatings.splice(selectedRatings.indexOf(selectedRating), 1)
        } else {
            selectedRatings.push(selectedRating)
        }

        this.setState({ selectedRatings }, () => {
            this.handleFiltersChange("ratings");
        })
    }

    handlePropertyAmenityChange = (selectedPropertyAmenity) => {
        let { selectedPropertyAmenities } = this.state;
        if (selectedPropertyAmenities.find(amenity => amenity === selectedPropertyAmenity)){
            selectedPropertyAmenities.splice(selectedPropertyAmenities.indexOf(selectedPropertyAmenity), 1)
        } else {
            selectedPropertyAmenities.push(selectedPropertyAmenity)
        }

        this.setState({ selectedPropertyAmenities }, () => {
            this.handleFiltersChange("propertyAmenities");
        })
    }

    handleChangeNameFilter(selectedSupplier){
        this.setState({selectedSupplier: selectedSupplier, propertyName: selectedSupplier === undefined ? "" : selectedSupplier}, () => {
            this.handleFiltersChange();

        })
    }

    /* toggle or hide a filter in mobile */
    toggleFilters = (current) => {
        let filters = this.state.filters;
        Object.keys(filters).forEach(key => {
            if (key !== current){
                filters[key] = false
            } else {
                filters[key] = !this.state.filters[key]
            }
        })
        
        this.setState({ filters });
    }

    /* general function after any filter changes */
    handleFiltersChange(lastFilter) {
        const { suppliers } = this.props;
        let res = [];

        suppliers.forEach((val, idx) => {
            let supplierIteration = JSON.parse( JSON.stringify(val))
            let isValidSupplierName = false;
            if (this.state.selectedSupplier === undefined){
                isValidSupplierName = true
            } else {
                if (supplierIteration !== undefined){
                    if (this.props.isLodging === false){
                        if (supplierIteration.ProductName.toLowerCase().match(this.state.selectedSupplier.toLowerCase())) {
                            isValidSupplierName = true;
                        }
                    } else {
                        if (supplierIteration.Supplier.SupplierName.toLowerCase().match(this.state.selectedSupplier.toLowerCase())) {
                            isValidSupplierName = true;
                        }
                    }
                }
            }
            // neighborhood validation

            let isValidNeighborhood = false
            if (this.state.selectedNeighborhoods.length === 0 || lastFilter === "ignoreNeighborhoods"){
                isValidNeighborhood = true
            } else {
                if (supplierIteration.Neighborhood){
                    if (this.state.selectedNeighborhoods.indexOf(supplierIteration.Neighborhood.name) >= 0) {
                        isValidNeighborhood = true
                    } else {
                        isValidNeighborhood = false
                    }
                } else {
                    isValidNeighborhood = false
                }
            }

            let isValidTrustYou = false
            if (this.state.selectedTrustYous.length === 0 || lastFilter === "ignoreTrustyous"){
                isValidTrustYou = true
            } else {
                if (supplierIteration.Trustyou){
                    if (this.state.selectedTrustYous.indexOf(supplierIteration.Trustyou.api_response.score_description) >= 0) {
                        isValidTrustYou = true
                    } else {
                        isValidTrustYou = false
                    }
                } else {
                    isValidTrustYou = false
                }
            }

            let isValidPrice = true;
            let newProductsLodging = supplierIteration.Products_Lodging.filter(room => room.FromPrice >= this.state.selectedPrices.min && room.FromPrice <= this.state.selectedPrices.max)
            supplierIteration.Products_Lodging = newProductsLodging;
            if (supplierIteration.Products_Lodging.length === 0 && this.props.make) {
                isValidPrice = false;
            }

            let isValidBedroom = true;
            if (this.state.selectedBedroom !== undefined){
                if (this.state.selectedBedroom === "Den"){
                    newProductsLodging = supplierIteration.Products_Lodging.filter(room => room.WithDen === 1)
                } else {
                    newProductsLodging = supplierIteration.Products_Lodging.filter(room => room.Bedrooms === this.state.selectedBedroom )
                }
                supplierIteration.Products_Lodging = newProductsLodging;
                if (supplierIteration.Products_Lodging.length === 0) {
                    isValidBedroom = false;
                }
            }

            let isValidRoomType = true;
            if (this.state.selectedRoomType !== undefined){
                let newProductsLodging = supplierIteration.Products_Lodging.filter(room => room.Type === this.state.selectedRoomType )
                supplierIteration.Products_Lodging = newProductsLodging;
                if (supplierIteration.Products_Lodging.length === 0) {
                    isValidBedroom = false;
                }
            }

            let isValidRoomAmenity = true;
            if (this.state.selectedRoomAmenities.length > 0){
                let newProductsLodging = supplierIteration.Products_Lodging.filter(room => {
                    if (room.Attributes.find(attr => attr.Name === this.state.selectedRoomAmenities[0])){
                        return true
                    }
                    return false;
                })
                supplierIteration.Products_Lodging = newProductsLodging;
                if (supplierIteration.Products_Lodging.length === 0) {
                    isValidRoomAmenity = false;
                } 
            }

            let isValidPropertyAmenity = false;
            if (this.state.selectedPropertyAmenities.length > 0){
                supplierIteration.SupplierAttributes.forEach(attr => {
                    if (this.state.selectedPropertyAmenities.find(am => am === attr.Name)){
                        isValidPropertyAmenity = true;
                    }
                })
            } else {
                isValidPropertyAmenity = true;
            }

            let isValidPackage = false;
            if (this.state.selectedPackages.length === 0 || lastFilter === "ignorePackages"){
                isValidPackage = true
            } else {
                supplierIteration.Products_Lodging.forEach((room, idx) => {
                    let newPackages = room.Packages.filter(pckg => this.state.selectedPackages.indexOf(pckg.PackageName) > -1)
                    room.Packages = newPackages;
                    
                })
                let newProductsLodging = supplierIteration.Products_Lodging.filter(room => room.Packages.length > 0 )
                supplierIteration.Products_Lodging = newProductsLodging;

                if (supplierIteration.Products_Lodging.length === 0) {
                    isValidPackage = false;
                } else {
                    isValidPackage = true;
                }
            }

            let isValidRating = false;
            if (this.state.selectedRatings.length === 0 || lastFilter === "ignoreRatings"){
                isValidRating = true;
            } else {
                let newProductsLodging = supplierIteration.Products_Lodging.filter(room => { 
                    return (this.state.selectedRatings.indexOf(room.UnitRating) > -1) })
                supplierIteration.Products_Lodging = newProductsLodging;
                if (supplierIteration.Products_Lodging.length === 0) {
                    isValidRating = false;
                } else {
                    isValidRating = true;
                }
            }

            let isValidItem = true;
            if (this.props.renderSoldOuts === false && supplierIteration.Products_Lodging.length === 0 && this.props.make) {
                isValidItem = false;
            }

            // decision to validate supplier
            if (isValidSupplierName && isValidNeighborhood && isValidItem && isValidTrustYou && isValidBedroom && isValidRoomType && isValidPrice && isValidPackage && isValidPropertyAmenity && isValidRoomAmenity && isValidRating) {
                res.push(supplierIteration);
            }

            // push state
            if (idx === (suppliers.length - 1)) {
                if (lastFilter !== "ignoreNeighborhoods" && lastFilter !== "ignoreTrustyous" && lastFilter !== "ignoreBedrooms" && lastFilter !== "ignoreRoomTypes" && lastFilter !== "ignorePackages" && lastFilter !== "ignoreRoomAmenities" && lastFilter !== "ignorePropertyAmenities" && lastFilter !== "ignoreRatings"){
                    const state = { ...this.state }
                    this.setState(state, () => {
                        if (this.props.isMobile){
                            let state = this.state;
                            let filters = {};
                            Object.keys(state).forEach(key => {
                                if (key.indexOf("selected") >= 0){
                                    filters[key] = state[key]
                                }
                            })
                            setLodgingFilters(filters);
                        }
                        this.props.onChange(res);
                        this.handleBuildNeighborhoods(res, true, lastFilter)
                        this.handleBuildBedrooms(res, true, lastFilter)
                        this.handleBuildRoomTypes(res, true, lastFilter)
                        this.handleBuildPackages(res, true, lastFilter)
                        this.handleBuildPropertyAmenities(res, true, lastFilter)
                        this.handleBuildRoomAmenities(res, true, lastFilter)
                        this.handleBuildRatings(res, true, lastFilter)
                    });
                }
            }
        });
        return res;
    }

    /* RENDERS OF EACH FILTER */ 
    handleRenderByName = (idx) => {
        const isRenderByNameSelected = this.state.filters.name;
        return (
            <div key={idx} className="filter byName">
                <div onClick={this.props.isMobile? () => this.toggleFilters("name") : null} className={isRenderByNameSelected ? "head radius" : "head"}>
                    <Typography variant="h6" className="title">
                        <IntlMessage id={this.getFilterTitle("name", "filter.property_name.title")} />
                    </Typography>
                    {isRenderByNameSelected ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                </div>
                <div style={this.props.isMobile && !isRenderByNameSelected ? {display:"none"} : {display:"inherit"} } className="content">
                    {
                        window.innerWidth < 991
                            ? <Input 
                                disabled={this.state.selectedSupplier !== undefined ? true : false} 
                                label="Type property name" 
                                value={this.state.propertyName || this.state.selectedSupplier || ""} 
                                onChange={(e)=>this.handlePropertyNameTextField(e)} 
                            />
                            : <TextField 
                            autoComplete='off' 
                            disabled={this.state.selectedSupplier !== undefined ? true : false} 
                            id="outlined-dense" 
                            className="inputSearch" 
                            label="Type property name" 
                            margin="dense" 
                            variant="outlined" 
                            fullWidth 
                            value={this.state.propertyName || ''} 
                            onChange={(e)=>this.handlePropertyNameTextField(e)} 
                            />
                    }
                    {this.state.selectedSupplier !== undefined ? <span onClick={()=>this.handleChangeNameFilter(undefined)}><SpotlioIcon color={"#d0d0d0"} size={18} icon="status-closed"/></span> : null}
                    {this.state.suggestions.length > 0 && this.state.selectedSupplier === undefined  && this.state.propertyName.length > 2 ?
                    <div className="suggestions">
                        {this.state.suggestions.map((suggestion) => {
                            return <div onClick={()=>this.handleChangeNameFilter(suggestion)}className="suggestion">{this.getAutoComplete(suggestion, this.state.propertyName)}</div>
                        })}
                    </div> : null}
                </div>
            </div>
        );
    }

    handleRenderByNeighborhood = (idx) => {
        return this.state.neighborhoods.length > 0 ? (
            <div key={idx} className="filter byNeighborhood">
                <React.Fragment>
                    <div onClick={this.props.isMobile? () => this.toggleFilters("neighborhood") : null} className="head">
                        <Typography variant="h6" className="title">{this.getFilterTitle("neighborhood", "Neighborhood")}</Typography>
                        {this.state.neighborhood ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div  style={this.props.isMobile && !this.state.filters.neighborhood ? {display:"none"} : {display:"block"} } className="content">
                            {this.state.neighborhoods.map((option, index) => {
                                const optionValue = option[1] ? option[1] : "0";
                                return(
                                    <div key={index} className="neighborhoods">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedNeighborhoods.find(neighborhood => neighborhood === option[0])}
                                                    onChange={()=>this.handleNeighborhoodsChange(option[0])}
                                                    defaultChecked={false}
                                                    color="default"/>
                                            } label={
                                                <span
                                                    className="neighbordhoodLabel"
                                                    style={{color: this.state.neighborhoodsColors[index] && this.state.neighborhoodsColors[index].color}}
                                                >
                                                    {option[0]} 
                                                </span>
                                            } labelPlacement="end" 
                                        />
                                        <span style={{color: this.state.neighborhoodsColors[index] && this.state.neighborhoodsColors[index].color}} className="counter">
                                            {option[2] === "selected" && null}
                                            {option[2] === "+" && "(+" + optionValue + ")"}
                                            {!option[2] && "(" + optionValue + ")"}
                                        </span>
                                    </div>
                                )
                            })}
                    </div>
                </React.Fragment>
            </div>
        ) : null
    }

    handleRenderByTrustYou = (idx) => {
        return this.state.neighborhoods.length > 0 ? (
            <div key={idx} className="filter byTrustYou">
                <React.Fragment>
                    <div onClick={this.props.isMobile? () => this.toggleFilters("trustyou") : null} className="head">
                        <Typography variant="h6" className="title">{this.getFilterTitle("trustyou", "TrustYou")}</Typography>
                        {this.state.trustyou ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div  style={this.props.isMobile && !this.state.filters.trustyou ? {display:"none"} : {display:"block"} } className="content">
                            {this.state.trustYous.map((option, index) => {
                                return(
                                    <div key={index} className="trustyous">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={()=>this.handleTrustYouChange(option[0])}
                                                    defaultChecked={false}
                                                    color="default"/>
                                            } label={
                                                <span>
                                                    {option[0]} {option[2] === "selected" ? null : option[2] === "+" ? " (+" + option[1] + ")" : "(" + option[1] + ")"}
                                                </span>
                                            } labelPlacement="end" />
                                    </div>
                                )
                            })}
                    </div>
                </React.Fragment>
            </div>
        ) : null
    }

    handleRenderByPrice = (idx) => {
        if (this.props.make) {
            return (
                <div key={idx} className="filter byPrice">
                    <div onClick={this.props.isMobile? () => this.toggleFilters("price") : null} className="head">
                        <Typography variant="h6" className="title"><IntlMessage id={this.getFilterTitle("price","filter.price.title")} /></Typography>
                        {this.state.price ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div style={this.props.isMobile && !this.state.filters.price ? {display:"none"} : {display:"inherit"} } className="content">
                        <InputRange
                            maxValue={this.state.rangePrices.max}
                            minValue={this.state.rangePrices.min}
                            value={this.state.selectedPrices}
                            onChange={value => this.setState({ selectedPrices: value })}
                            onChangeComplete={()=>this.handleFiltersChange()}
                            formatLabel={value => <Currency value={value}/> }
                            />
                    </div>
                </div>
            );
        }
        return null;
    }

    getBedroomsOptionName = (option) => {
        let studioLabel = "Studio";
        if(this.props.config.config.filterOptions
            && this.props.config.config.filterOptions.bedrooms 
            && this.props.config.config.filterOptions.bedrooms.labels 
            && this.props.config.config.filterOptions.bedrooms.labels.studio
        ) {
            studioLabel = this.props.config.config.filterOptions.bedrooms.labels.studio;
        }

        let bedroomLabel = "Bedrooms";
        if(this.props.config.config.filterOptions
            && this.props.config.config.filterOptions.bedrooms 
            && this.props.config.config.filterOptions.bedrooms.labels 
            && this.props.config.config.filterOptions.bedrooms.labels.bedroom
        ) {
            bedroomLabel = this.props.config.config.filterOptions.bedrooms.labels.bedroom;
        }

        let denLabel = "Den";
        if(this.props.config.config.filterOptions
            && this.props.config.config.filterOptions.bedrooms 
            && this.props.config.config.filterOptions.bedrooms.labels 
            && this.props.config.config.filterOptions.bedrooms.labels.den
        ) {
            denLabel = this.props.config.config.filterOptions.bedrooms.labels.den;
        }

        switch(option[0]){
            case 0:
                return studioLabel;
            case "Den":
                return denLabel;
            default:
                return option[0] + " " + bedroomLabel;
        }
    }

    handleRenderByBedroom = (idx) => {
        if (this.props.make && this.state.bedrooms.length > 0) {
            return (
                <div key={idx} className="filter byBedroom">
                    <div onClick={this.props.isMobile? () => this.toggleFilters("bedroom") : null} className="head">
                        <Typography variant="h6" className="title"><IntlMessage id={this.getFilterTitle("bedrooms","filter.bedrooms.title")} /></Typography>
                        {this.state.bedroom ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div style={this.props.isMobile && !this.state.filters.bedroom ? {display:"none"} : {display:"inherit"} } className="content">
                        {this.state.bedrooms.map((option, index) => {
                            return(
                                <div key={index} className="bedrooms">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={option[0] === this.state.selectedBedroom}
                                                onChange={()=>this.handleBedroomChange(option[0])}
                                                defaultChecked={false}
                                                color="default"
                                            />
                                        } 
                                        label={
                                            <span>
                                                {this.getBedroomsOptionName(option)}  
                                            </span>
                                        } 
                                        labelPlacement="end" 
                                    />
                                    <span className="counter">
                                        {option[2] === "selected" && null}
                                        {option[2] === "+" && "(+" + option[1] + ")"}
                                        {!option[2] && "(" + option[1] + ")"}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            );
        }
        return null;
    }

    handleRenderByRoomType = (idx) => {
        if (this.props.make && this.state.roomTypes.length > 0) {
            return (
                <div key={idx} className="filter byRoomType">
                    <div onClick={this.props.isMobile? () => this.toggleFilters("roomType") : null} className="head">
                        <Typography variant="h6" className="title"><IntlMessage id={this.getFilterTitle("roomTypes","filter.room_type.title")} /></Typography>
                        {this.state.roomType ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div style={this.props.isMobile && !this.state.filters.roomType ? {display:"none"} : {display:"inherit"} } className="content">
                        {this.state.roomTypes.map((option, index) => {
                                return(
                                    <div key={index} className="roomTypes">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={option[0] === this.state.selectedRoomType}
                                                    onChange={()=>this.handleRoomTypeChange(option[0])}
                                                    defaultChecked={false}
                                                    color="default"/>
                                            } label={
                                                <span>
                                                    {option[0]}  
                                                </span>
                                            } labelPlacement="end" 
                                        />
                                        <span className="counter">
                                            {option[2] === "selected" && null}
                                            {option[2] === "+" && "(+" + option[1] + ")"}
                                            {!option[2] && "(" + option[1] + ")"}
                                        </span>
                                    </div>
                                )
                        })}
                    </div>
                </div>
            );
        }
        return null;
    }

    handleRenderByPackages = (idx) => {
        return this.state.packages.length > 0 ? (
            <div key={idx} className="filter byPackages">
                <React.Fragment>
                    <div onClick={this.props.isMobile? () => this.toggleFilters("packages") : null} className="head">
                        <Typography variant="h6" className="title">{this.getFilterTitle("packages", "Lodging Offers")}</Typography>
                        {this.state.package ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div  style={this.props.isMobile && !this.state.filters.package ? {display:"none"} : {display:"block"} } className="content">
                            {this.state.packages.map((option, index) => {
                                return(
                                    <div key={index} className="packages">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={()=>this.handlePackagesChange(option[0])}
                                                    defaultChecked={false}
                                                    color="default"/>
                                            } label={
                                                <span
                                                    className="packageLabel"
                                                >
                                                    {option[0]} 
                                                </span>
                                            } labelPlacement="end" 
                                        />
                                        <span className="counter">
                                            {option[2] === "selected" && null}
                                            {option[2] === "+" && "(+" + option[1] + ")"}
                                            {!option[2] && "(" + option[1] + ")"}
                                        </span>
                                    </div>
                                )
                            })}
                    </div>
                </React.Fragment>
            </div>
        ) : null
    }

    handleRenderByRoomAmenity = (idx) => {
        if (this.props.make && this.state.roomAmenities.length > 0) {
            return (
                <div key={idx} className="filter byRoomAmenity">
                    <div onClick={this.props.isMobile? () => this.toggleFilters("roomAmenity") : null} className="head">
                        <Typography variant="h6" className="title"><IntlMessage id={this.getFilterTitle("roomAmenities","filter.unit_ammenities.title")} /></Typography>
                        {this.state.roomAmenity ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div style={this.props.isMobile && !this.state.filters.roomAmenity ? {display:"none"} : {display:"inherit"} } className="content">
                        {this.state.roomAmenities.map((option, index) => {
                                return(
                                    <div key={index} className="roomTypes">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.selectedRoomAmenities.find(am => am === option[0])}
                                                    onChange={()=>this.handleRoomAmenityChange(option[0])}
                                                    defaultChecked={false}
                                                    color="default"/>
                                            } label={
                                                <span>
                                                    {option[0]}  
                                                </span>
                                            } labelPlacement="end" 
                                        />
                                        <span className="counter">
                                            {option[2] === "selected" && null}
                                            {option[2] === "+" && "(+" + option[1] + ")"}
                                            {!option[2] && "(" + option[1] + ")"}
                                        </span>
                                    </div>
                                )
                        })}
                    </div>
                </div>
            );
        }
        return null;
    }

    handleRenderByPropertyAmenity = (idx) => {
        return this.state.propertyAmenities.length > 0 ? (
            <div key={idx} className="filter byPropertyAmenity">
                <div onClick={this.props.isMobile? () => this.toggleFilters("propertyAmenity") : null} className="head">
                    <Typography variant="h6" className="title"><IntlMessage id={this.getFilterTitle("propertyAmenities","filter.ammenities.title")} /></Typography>
                    {this.state.roomAmenity ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                </div>
                <div style={this.props.isMobile && !this.state.filters.propertyAmenity ? {display:"none"} : {display:"inherit"} } className="content">
                    {this.state.propertyAmenities.map((option, index) => {
                            return(
                                <div key={index} className="roomTypes">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.selectedPropertyAmenities.find(am => am === option[0])}
                                                onChange={()=>this.handlePropertyAmenityChange(option[0])}
                                                defaultChecked={false}
                                                color="default"/>
                                        } label={
                                            <span>
                                                {option[0]}  
                                            </span>
                                        } labelPlacement="end" 
                                    />
                                    <span className="counter">
                                        {option[2] === "selected" && null}
                                        {option[2] === "+" && "(+" + option[1] + ")"}
                                        {!option[2] && "(" + option[1] + ")"}
                                    </span>
                                </div>
                            )
                    })}
                </div>
            </div>
        )
        : null;
    }

    handleRenderByRating = (idx) => {
        if (this.props.make && this.state.ratings.length > 0) {
            return (
                <div key={idx} className="filter byRating">
                    <div onClick={this.props.isMobile? () => this.toggleFilters("rating") : null} className="head">
                        <Typography variant="h6" className="title"><IntlMessage id={this.getFilterTitle("rating","filter.quality.title")} /></Typography>
                        {this.state.filters.rating ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                    </div>
                    <div style={this.props.isMobile && !this.state.filters.rating ? {display:"none"} : {display:"inherit"} } className="content">
                        {this.state.ratings
                        .sort((a, b) => { return a[0] < b[0] ? 1 : -1})
                        .map((option, index) => {
                            return(
                                <div key={index} className="ratings">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.selectedRatings.find(rating => rating === option[0])}
                                                onChange={()=>this.handleRatingChange(option[0])}
                                                defaultChecked={false}
                                                color="default"/>
                                        } label={
                                            <UnitRatings ratings={option[0]} />
                                        } labelPlacement="end" 
                                    />
                                    <span className="counter">
                                        {option[2] === "selected" && null}
                                        {option[2] === "+" && "(+" + option[1] + ")"}
                                        {!option[2] && "(" + option[1] + ")"}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            );
        }
        return null;
    }

    handleRenderFilters = () => {
        return this.state.filtersOrder.map(idx => {
            switch(idx) {
                case 'name': return this.handleRenderByName(idx);
                case 'neighborhood': return this.handleRenderByNeighborhood(idx);
                case 'price': return this.handleRenderByPrice(idx);
                case 'bedroom': return this.handleRenderByBedroom(idx);
                case 'room_type': return this.handleRenderByRoomType(idx);
                case 'packages': return this.handleRenderByPackages(idx);
                case 'room_amenity': return this.handleRenderByRoomAmenity(idx);
                case 'property_amenity': return this.handleRenderByPropertyAmenity(idx);
                case 'rating': return this.handleRenderByRating(idx);
                // case 'trustyou': return this.handleRenderByTrustYou(idx);
                default: return null;
            }
        })
    }

    getFilterTitle = (filter, alternativeTitle) => {
        if (this.props.config && this.props.config.config && this.props.config.config.filterOptions && this.props.config.config.filterOptions[filter] && this.props.config.config.filterOptions[filter].title){
            return this.props.config.config.filterOptions[filter].title
        }
        return alternativeTitle;
    }

    render() {
        return (
            <React.Fragment>
                <div className="filters">
                    { this.handleRenderFilters() }
                </div>
            </React.Fragment>
        )
    }
}
